/*       */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from 'app/components/molecules/Alert/Alert';
import Flex from 'app/components/atoms/Flex/Flex';
import ContentArea from 'app/components/molecules/PageContent/ContentArea';
import PageTemplate from 'app/components/templates/PageTemplate';

/**
 * If the user is not allowed to see the page.
 */
class PageNotAllowed extends Component {
    static propTypes = {
        title: PropTypes.string,
        errorOptions: PropTypes.object,
        permissionError: PropTypes.bool,
        doesNotExist: PropTypes.bool,
        entityType: PropTypes.bool,
    };
    /**
     * @override
     */
    render() {
        const { title, errorOptions, permissionError, padded, doesNotExist, entityType, hideBackMessage } = this.props;
        return (
            <PageTemplate title={errorOptions.isError && !permissionError ? 'Error' : 'User is not allowed'} overflowHidden>
                <ContentArea>
                    <Flex grow style={{ paddingTop: padded ? 'calc(50% + 60px)' : '', height: '100%', justifyContent: 'center' }}>
                        <Alert type="error">
                            <div>
                                {errorOptions.isError && !permissionError ? (
                                    errorOptions.detail
                                ) : (
                                    <p>
                                        {doesNotExist
                                            ? `The ${entityType ? 'entity type' : 'classification'} does not exist for following `
                                            : `You don't have permission to see `}
                                        <b>{title}</b>
                                    </p>
                                )}
                            </div>
                            {!hideBackMessage && <div>
                                Click here to navigate to{' '}
                                <Link to="/" style={{ color: 'purple' }}>
                                    homepage
                                </Link>
                                .
                            </div>}
                        </Alert>
                    </Flex>
                </ContentArea>
            </PageTemplate>
        );
    }
}

const mapStateToProps = state => {
    return {
        errorOptions: state.app.errorOptions,
    };
};
export default connect(mapStateToProps, {})(PageNotAllowed);
